import { eventBus, EVENTS } from "./EventBus.js";

function Utils() {}

/**
 * Secondo popup per gioco_codice
 * I giochi possono avere due checkbox : maggiorenne e passaporto se richiesti dal gioco,
 * possono essere usati anche singolarmente nella dinamica di gioco.
 *
 *
 * @param postRenderCallback
 */
function getExtraFields(postRenderCallback) {
  try {
    const displayMaggiorenne = window.maggiorenne ? "flex" : "none";
    const displayPassaporto = window.passaporto ? "flex" : "none";
    const disableSubmit =
      window.passaporto || window.maggiorenne ? "disable" : "";
    $("#first-step-custom").hide();
    $("#messaggio_titolo_popup").append(`
        <div id="second-step-custom">
            <div class="breadcrumb_container flex" style="position: absolute;top: 20px;left: 35px;color: #0f4f9b;margin-top: 0" >
                <button id="back-button" style="display: flex;align-items: center">
                    <img src="https://media.rds.it/web/web-site-brandnew/svg/path-copy-3.svg" class="breadcrumb_arrow">
                    <span class="font_14">Indietro</span>
                </button>
            </div>
            <div class="sofia_font font_12  flex align_center" style="margin: 10px 0 20px">
                <span class="font_30 font_22_mobile">Inserisci il tuo codice</span>
            </div>
            <div style="text-align: start">
            <div id="dati" style="justify-content: space-between; height:33px; margin: 20px 0 50px" class="container_checkbox row fieldset-container">
               <fieldset class="fieldset-gray fieldset-dati-codice fieldset_in_edit">
                    <legend>Codice</legend>
                    <div id="blocco_dati_codice_label" class="content_show"></div>
                    <div class="flex align_center">
                        <input id="codice" name="codice" class="register-input sofia_font font_16" type="text" value="" maxlength="13" oninput="this.value = this.value.toUpperCase()" style="text-transform:uppercase">
                        <img class="icon-error" src="https://media.rds.it/web/web-site-brandnew/svg/icon-error.svg">
                    </div>
               </fieldset>
               <div id="error-message-codice" class="error-message-citta error-messages font-size-14 sofia_font"></div>
              </div>
              <div class="container_checkbox row" style="margin: 20px 0;display: ${displayMaggiorenne}">
                <label class="container_checkbox flex">
                    <input type="checkbox" id="checkbox-maggiorenne" name="maggiorenne" class="consensi-check obbligatorio_check" value="1"/>
                    <span class="checkmark"></span>
                    <img class="icon-error" id="error_radio-consensi-10" style="visibility:hidden;width: 20px;position:relative;top:-10px;left:0px;display:block;"
                        src="https://media.rds.it/web/web-site-brandnew/svg/icon-error.svg">
                </label>
                <span class="font_20 font_16_mobile opacity_8">Sono maggiorenne</span>
              </div>
              <div id="container-passaporto" style="margin: 20px 0;display: ${displayPassaporto}" class="container_checkbox row">
                <label class="container_checkbox flex">
                    <input type="checkbox" id="checkbox-passaporto" name="passaporto" class="consensi-check obbligatorio_check" value="1"/>
                    <span class="checkmark"></span>
                    <img class="icon-error" id="error_radio-consensi-10" style="visibility:hidden;width: 20px;position:relative;top:-10px;left:0px;display:block;"
                        src="https://media.rds.it/web/web-site-brandnew/svg/icon-error.svg">
                </label>
                <span class="font_20 font_16_mobile opacity_8">Ho un passaporto valido</span>
              </div>
            </div>
            <div class="popup-conferma-button flex" style="width: 100%; margin-top: 40px">
                <button id="submit-button" class="popup-conferma-close font_20 bold button uppercase disabled" disabled="${disableSubmit}" > Continua </button>
            </div>
        </div>`);

    let container_passaporto_sel = $("#container-passaporto");
    let container_codice_sel = $("#dati");

    let check_maggiorenne = $("#checkbox-maggiorenne");
    let check_passaporto = $("#checkbox-passaporto");
    let input_codice = $("#codice");
    let submit_button = $("#submit-button");
    let submit_button_1 = document.getElementById("submit-button");
    let back_button = $("#back-button");

    if (!disableSubmit) {
      submit_button_1.removeAttribute("disabled");
      submit_button_1.classList.remove("disabled");
      submit_button_1.classList.add("skew");
    }

    $("#checkbox-maggiorenne,#checkbox-passaporto").click(function () {
      if (
        (check_maggiorenne[0].checked || !window.maggiorenne) &&
        (check_passaporto[0].checked || !window.passaporto)
      ) {
        // submit_button[0].className = 'popup-conferma-close font_20 bold button uppercase skew';
        submit_button_1.removeAttribute("disabled");
        submit_button_1.classList.remove("disabled");
        submit_button_1.classList.add("skew");
      } else {
        submit_button_1.disabled = "disabled";
        submit_button_1.classList.add("disabled");
        submit_button_1.classList.remove("skew");
        // submit_button[0].className = 'popup-conferma-close font_20 bold button uppercase skew disabled';
      }
    });

    submit_button.click(function () {
      let codice = $("#codice")[0].value;
      if (codice.length !== 13) {
        console.log("codice non valido");
        $("#codice").parents(".fieldset-gray").addClass("fieldset-error");
        $("#error-message-codice").text(
          "Il codice deve essere di 13 caratteri."
        );
      } else {
        console.log("codice", codice);
        if (typeof postRenderCallback === "function") {
          $("#second-step-custom").remove();
          $("#first-step-custom").remove();
          window.closePopupCustom();
          postRenderCallback(window.gioco_id, codice);
        }
      }
    });

    back_button.click(function () {
      console.log("back-button");
      $("#second-step-custom").remove();
      $("#first-step-custom").show();
    });
  } catch (e) {
    actualAlert(e);
  }
}

Utils.prototype = {
  SETTINGS: {
    DATERANGEPICKER: {
      format: "DD/MM/YYYY",
      separator: " - ",
      applyLabel: "CERCA",
      cancelLabel: "ANNULLA",

      fromLabel: "From",
      toLabel: "To",
      customRangeLabel: "Custom",
      daysOfWeek: ["Do", "Lu", "Ma", "Me", "Gi", "Ve", "Sa"],
      monthNames: [
        "Gennaio",
        "Febbrario",
        "Marzo",
        "Aprile",
        "Maggio",
        "Giugno",
        "Luglio",
        "Agosto",
        "Settembre",
        "Ottobre",
        "Novembre",
        "Dicembre",
      ],
      firstDay: 1,
    },
  },

  // EVENTS: {
  //     RENDER_USER_LOGGED: "RENDER_USER_LOGGED",
  //     RENDER_USER_NOT_LOGGED: "RENDER_USER_NOT_LOGGED"
  // },
  constructor: Utils,
  isElementInView: function (element, fullyInView) {
    var pageTop = $(window).scrollTop();
    var pageBottom = pageTop + $(window).height();
    var elementTop = $(element).offset().top;
    var elementBottom = elementTop + $(element).height();

    if (fullyInView === true) {
      return pageTop < elementTop && pageBottom > elementBottom;
    } else {
      return elementTop <= pageBottom && elementBottom >= pageTop;
    }
  },
  showWaitingLoader: function () {
    $("#overlay-wait").fadeIn("fast");
  },
  hideWaitingLoader: function () {
    $("#overlay-wait").fadeOut("fast");
  },
  quotesToHtmlEntities(html) {
    return html.replace(/'/g, "&#39;").replace(/"/g, "&#34;");
  },
  setCookie(name, value, days) {
    var expires = "";
    if (days) {
      var date = new Date();
      date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
      expires = "; expires=" + date.toUTCString();
    }
    if (typeof value == "object") {
      value = JSON.stringify(value);
    }

    var e = window.location.hostname.split(".");
    e.shift();
    var domain_name = "." + e.join(".");

    document.cookie =
      name +
      "=" +
      (value || "") +
      expires +
      "; domain=" +
      domain_name +
      "; path=/";
  },
  getCookie(name) {
    var nameEQ = name + "=";
    var ca = document.cookie.split(";");
    for (var i = 0; i < ca.length; i++) {
      var c = ca[i];
      while (c.charAt(0) == " ") c = c.substring(1, c.length);
      if (c.indexOf(nameEQ) == 0) {
        let value = c.substring(nameEQ.length, c.length);
        try {
          value = JSON.parse(value);
        } catch (error) {
          value = decodeURIComponent(value);
        }
        return value;
      }
    }
    return null;
  },
  eraseCookie(name) {
    document.cookie =
      name + "=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;";
  },
  downloadURI(uri, name) {
    var link = document.createElement("a");
    link.setAttribute("download", name);
    link.href = uri;
    document.body.appendChild(link);
    link.click();
    link.remove();
  },

  alert(msg) {
    try {
      console.log(msg);
      $(".rds-modal-popup-box").css("width", "262px");
      $(".rds-modal-popup-box").css("height", "auto");
      $("#rds-popup-content").html(window.templates["alert-ok"]);
      $("#rds-alert-ok-msg").html(msg);
      RDSMODALPOPUP.open();
    } catch (err) {
      return actualAlert(msg);
    }
  },

  // alertErrort(msg) {
  //
  // try {
  //
  //     console.log(msg);
  //     $(".rds-modal-popup-box").css("width", "262px");
  //     $(".rds-modal-popup-box").css("height", "auto");
  //     $("#rds-popup-content").html(window.templates["alert-ko"]);
  //     $("#rds-alert-ko-msg").html(msg);
  //     RDSMODALPOPUP.open();
  //
  //     // WEBTREKK_DL.sendEvent('errore', {2: msg});
  //
  //     } catch (err) {
  //         return actualAlert(msg);
  //     }
  //
  // },

  alertError(msg) {
    try {
      $("#btnNo").hide();
      $(".img-warning")
        .find("img")
        .attr(
          "src",
          "https://media.rds.it/web/web-site-brandnew/svg/rds-problemi-accesso.svg"
        );

      $("#messaggio_titolo_popup").html(msg);
      $("#messaggio_sottotitolo_popup").html("");

      $("#btnYes").html("OK");
      window.openPopup();

      $("#btnYes")
        .off()
        .click(function () {
          $(".popup-messaggio-main").hide();
        });
    } catch (err) {
      return actualAlert(msg);
    }
  },

  alertMessage(msg, yesCallback) {
    try {
      $("#btnNo").hide();
      $("#messaggio_sottotitolo_popup").html("");
      $(".img-warning")
        .find("img")
        .attr(
          "src",
          "https://media.rds.it/web/web-site-brandnew/svg/rds-popup-successo2.svg"
        );

      $("#messaggio_titolo_popup").html(msg);
      $("#btnYes").html("OK");
      window.openPopup();

      $("#btnYes")
        .off()
        .click(function () {
          $(".popup-messaggio-main").hide();
          if (yesCallback) {
            yesCallback();
          }
        });
    } catch (err) {
      return actualAlert(msg);
    }
  },
  alertMessageGiochi(msg, yesCallback) {
    try {
      $("#btnNo").hide();
      $("#messaggio_sottotitolo_popup").html("");
      $(".img-warning")
        .find("img")
        .attr(
          "src",
          "https://media.rds.it/web/web-site-brandnew/svg/rds-popup-successo2.svg"
        );

      $("#messaggio_titolo_popup").html(msg);
      $("#btnYes").html("OK");
      window.openPopup();

      $("#btnYes")
        .off()
        .click(function () {
          $(".popup-messaggio-main").hide();
          if (yesCallback) {
            yesCallback();
          }
          popupPrimaDiGiocare();
        });
    } catch (err) {
      return actualAlert(msg);
    }
  },

  getParams() {
    let params = {};
    try {
      const splitted = window.location.search.substring(1).split("&");
      if (splitted[0]) {
        params = splitted.reduce((accumulator, i) => {
          const splParam = i.split("=");
          accumulator[splParam[0]] = splParam[1];
          return accumulator;
        }, {});
      }
    } catch (error) {}
    return params;
  },

  objectToQParams(obj) {
    return Object.entries(obj)
      .map(
        ([key, val]) => `${encodeURIComponent(key)}=${encodeURIComponent(val)}`
      )
      .join("&");
  },

  additionalParameter(
    msg,
    subMsg,
    yesCallback,
    noCallback,
    yesButton,
    noButton,
    postRenderCallback
  ) {
    try {
      $(".img-warning")
        .find("img")
        .attr(
          "src",
          "https://media.rds.it/web/web-site-brandnew/svg/rds-problemi-accesso.svg"
        );

      $("#btnNo").show();
      $("#btnYes").html(yesButton);
      $("#btnYes").attr("id", "btnYesGame");
      $("#btnNo").html(noButton);

      $("#messaggio_titolo_popup").html(msg);
      $("#messaggio_sottotitolo_popup").html(subMsg);
      $("#messaggio_titolo_popup").css("width", "75%");
      $("#messaggio_titolo_popup").append(
        '<br> <fieldset class="fieldset-gray fieldset-name">\n' +
          "                                        <legend>Telefono*</legend>" +
          '                                        <div class="flex align_center">' +
          '                                            <input id="telefono" name="telefono" class="register-input sofia_font" type="number" value=""' +
          '                                                   placeholder="Inserisci il tuo telefono">' +
          '                                            <img class="icon-error" src="https://media.rds.it/web/web-site-brandnew/svg/icon-error.svg">' +
          "                                        </div>" +
          "                                    </fieldset>" +
          '                             <div id="error-message-telefono" class="error-message-citta error-messages font-size-14 sofia_font"></div>'
      );
      window.openPopup();

      $("#btnYesGame")
        .off()
        .click(function () {
          if (
            $("#telefono").val().trim() != "" &&
            $("#telefono").val().trim().length > 4
          ) {
            $("#btnYesGame").attr("id", "btnYes");
            $(".popup-messaggio-main").hide();
            yesCallback();
          } else {
            $("#telefono").parents(".fieldset-gray").addClass("fieldset-error");
            $("#error-message-telefono").text(
              "Inserisci un numero di telefono valido"
            );
          }
        });

      $("#btnNo")
        .off()
        .click(function () {
          $("#btnYesGame").attr("id", "btnYes");
          $(".popup-messaggio-main").hide();
          noCallback();
        });

      if (typeof postRenderCallback === "function") {
        postRenderCallback();
      }
    } catch (err) {
      return actualAlert(msg);
    }
  },

  confirmCodiceFiscale(
    msg,
    subMsg,
    yesCallback,
    noCallback,
    yesButton,
    noButton,
    postRenderCallback
  ) {
    try {
      $(".img-warning")
        .find("img")
        .attr(
          "src",
          "https://media.rds.it/web/web-site-brandnew/svg/rds-problemi-accesso.svg"
        );
      $("#btnNo").show();
      $("#btnYes").html(yesButton);
      $("#btnYes").attr("id", "btnYesGame");
      $("#btnNo").html(noButton);
      $("#messaggio_titolo_popup").html(msg);
      $("#messaggio_sottotitolo_popup").html(subMsg);
      $("#messaggio_titolo_popup").css("width", "75%");
      $("#messaggio_titolo_popup").append(
        "<br> " +
          '                               <div class="sofia_font font_12  flex align_center" style="margin-bottom: 20px;">\n' +
          '                                    <label class="container_checkbox">\n' +
          '                                        <input type="checkbox" class="checkbox-date" id="flagMaggiorenne" name="flagMaggiorenne"  style="visibility: hidden;">\n' +
          '                                        <span class="checkmark"></span>\n' +
          "                                    </label>\n" +
          '                                    <span class="font_14">Dichiaro di essere Maggiorenne</span>\n' +
          "                                </div>" +
          '                                    <div id="mailGenitoreDiv"><fieldset class="fieldset-gray fieldset-name">\n' +
          "                                        <legend>Email Genitore*</legend>" +
          '                                        <div class="flex align_center">' +
          '                                            <input id="mailGenitore" name="mailGenitore" class="register-input sofia_font" type="text" value=""' +
          '                                                   placeholder="Inserisci la mail del Genitore">' +
          '                                            <img class="icon-error" src="https://media.rds.it/web/web-site-brandnew/svg/icon-error.svg">' +
          "                                        </div>" +
          "                                    </fieldset>" +
          '                             <div id="error-message-mail" class="error-message-citta error-messages font-size-14 sofia_font"></div>' +
          "                           </div><br>" +
          '                                     <fieldset class="fieldset-gray fieldset-name">\n' +
          "                                        <legend>Codice Fiscale*</legend>" +
          '                                        <div class="flex align_center">' +
          '                                            <input id="cf" name="cf" class="register-input sofia_font" type="text" value=""' +
          '                                                   placeholder="Inserisci il tuo Codice Fiscale">' +
          '                                            <img class="icon-error" src="https://media.rds.it/web/web-site-brandnew/svg/icon-error.svg">' +
          "                                        </div>" +
          "                                    </fieldset>" +
          '                             <div id="error-message-cf" class="error-message-citta error-messages font-size-14 sofia_font"></div>'
      );

      $("#flagMaggiorenne").click(function () {
        if ($("#flagMaggiorenne").is(":checked")) {
          $("#mailGenitoreDiv").hide();
          $("#mailGenitore").val("");
        } else {
          $("#mailGenitoreDiv").show();
        }
      });

      window.openPopup();
      $("#btnYesGame")
        .off()
        .click(function () {
          let user = JSON.parse(localStorage.getItem("rds_user"));

          if (
            !$("#flagMaggiorenne").is(":checked") &&
            $("#mailGenitore").val().trim() == ""
          ) {
            $("#mailGenitore")
              .parents(".fieldset-gray")
              .addClass("fieldset-error");
            $("#error-message-mail").text("Email tutore obbligatoria");
            return;
          } else {
          /*else if(!$("#flagMaggiorenne").is(':checked') && $("#mailGenitore").val().trim()==user.email.trim())
        {
          $("#mailGenitore").parents(".fieldset-gray").addClass("fieldset-error");
          $('#error-message-mail').text("Email del tutore deve essere diversa da quella dell'utente attuale");
          return;
        }*/
            $("#mailGenitore")
              .parents(".fieldset-gray")
              .removeClass("fieldset-error");
            $("#error-message-mail").text("");
          }

          if (
            $("#cf").val().trim() != "" &&
            $("#cf").val().trim().length == 16
          ) {
            $("#btnYesGame").attr("id", "btnYes");
            $(".popup-messaggio-main").hide();
            yesCallback();
          } else {
            $("#cf").parents(".fieldset-gray").addClass("fieldset-error");
            $("#error-message-cf").text("Codice Fiscale non Valido");
          }
        });

      $("#btnNo")
        .off()
        .click(function () {
          $("#btnYesGame").attr("id", "btnYes");
          $(".popup-messaggio-main").hide();
          noCallback();
        });

      if (typeof postRenderCallback === "function") {
        postRenderCallback();
      }
    } catch (err) {
      return actualAlert(msg);
    }
  },

  /**
   * Primo popup per gioco_codice
   * Il titolo e il testo del messaggio viene preso direttamente da wordpress
   *
   * @param msg
   * @param postRenderCallback
   */
  codicePerGiocare(msg, postRenderCallback) {
    try {
      $(".img-warning").hide();
      $(".popup-conferma-button").hide();
      $("#messaggio_titolo_popup").css("min-width", "75%");
      $("#messaggio_titolo_popup").text("");

      $("#messaggio_titolo_popup").append(`
        <div id="first-step-custom">
            <div class="sofia_font font_12 flex align_center" style="margin-bottom: 30px;">
                <span class="font_23 font_18_mobile" style="text-align: start" style="text-transform: uppercase;">
                    ${window.titolo_popup}
                </span>
            </div>
            <div class="flex row" style="margin-bottom: 20px">
                <div style=";margin-bottom: 30px; text-align: justify">
                    <span class="font_18 font_16_mobile mobile_line_height" style="font-weight:normal;">
                            ${window.testo_popup}
                    </span>
                </div>
                <div class="col-6 col-6-sm">
                    <label class="container_checkbox radio-container-checkbox">
                        <input id="si_codice" type="radio" name="ha_codice" value="1" />
                        <span class="checkmark radio-checkmark"></span>
                        <div class="checkmark-container"></div>
                        <span class="checkmark-radio-label">Si</span>
                    </label>
                </div>
                <div class="col-6 col-6-sm">
                    <label class="container_checkbox radio-container-checkbox">
                        <input id="no_codice" type="radio" name="ha_codice" value="0" />
                        <span class="checkmark radio-checkmark"></span>
                        <div class="checkmark-container"></div>
                        <span class="checkmark-radio-label">No</span>
                    </label>
                </div>
            </div>
            <div id="container-button" class="popup-conferma-button flex" style="width: 100%;visibility: hidden; height: 54px" >
                <button id="button_gioco_semplice" class="popup-conferma-close font_20 bold button skew uppercase" style="display: none"> Continua </button>
                <button id="button_gioco_custom" class="popup-conferma-close font_20 bold button skew uppercase" style="display: none">Continua</button>
            </div>
        </div>`);

      let button_semplice_sel = $("#button_gioco_semplice");
      let button_custom_sel = $("#button_gioco_custom");
      let container_button = $("#container-button");

      window.openPopup();
      $(".x-delete.popup-conferma-close")
        .one()
        .click(function () {
          $("#first-step-custom").remove();
          $("#second-step-custom").remove();
        });

      $("#no_codice").click(function () {
        console.log("no codice");
        if (container_button[0].style.visibility === "hidden") {
          container_button[0].style.visibility = "visible";
        }
        button_semplice_sel[0].style.display = "block";
        button_custom_sel[0].style.display = "none";
      });

      $("#si_codice").click(function () {
        console.log("si codice");
        if (container_button[0].style.visibility === "hidden") {
          container_button[0].style.visibility = "visible";
        }
        button_custom_sel[0].style.display = "block";
        button_semplice_sel[0].style.display = "none";
      });

      $("#button_gioco_semplice").click(function () {
        eventBus.emit(EVENTS.GIOCO_CUSTOM_NOCODICE);
        console.log("partecipa gioco semplice");
        //window.partecipaGiocoSemplice(window.gioco_id)
        if (typeof postRenderCallback === "function") {
          $("#first-step-custom").remove();
          window.closePopupCustom();
          postRenderCallback(window.gioco_id);
        }
      });

      $("#button_gioco_custom").click(function () {
        eventBus.emit(EVENTS.GIOCO_CUSTOM_CODICE);
        getExtraFields(postRenderCallback);
        // return 'getExtraFields';
      });
    } catch (e) {
      return actualAlert(msg);
    }
  },

  confirmCampiExtra(
    msg,
    subMsg,
    yesCallback,
    noCallback,
    yesButton,
    noButton,
    postRenderCallback
  ) {
    try {
      $(".img-warning")
        .find("img")
        .attr(
          "src",
          "https://media.rds.it/web/web-site-brandnew/svg/rds-problemi-accesso.svg"
        );
      $("#btnNo").show();
      $("#btnYes").html(yesButton);
      $("#btnYes").attr("id", "btnYesGame");
      $("#btnNo").html(noButton);
      $("#messaggio_titolo_popup").html(msg);
      $("#messaggio_sottotitolo_popup").html(subMsg);
      $("#messaggio_titolo_popup").css("width", "75%");
      $("#messaggio_titolo_popup").append(
        "<br> " +
          '                                       <fieldset class="fieldset-gray fieldset-name">\n' +
          "                                        <legend>Email Rappresentante Legale*</legend>" +
          '                                        <div class="flex align_center">' +
          '                                            <input id="mailRapLegale" name="mailRapLegale" class="register-input sofia_font" type="text" value=""' +
          '                                                   placeholder="Inserisci la mail del Rappresentante Legale">' +
          '                                            <img class="icon-error" src="https://media.rds.it/web/web-site-brandnew/svg/icon-error.svg">' +
          "                                        </div>" +
          "                                    </fieldset><br>" +
          '                                       <fieldset class="fieldset-gray fieldset-name">\n' +
          "                                        <legend>Nome Impresa*</legend>" +
          '                                        <div class="flex align_center">' +
          '                                            <input id="nomeImpresa" name="nomeImpresa" class="register-input sofia_font" type="text" value=""' +
          '                                                   placeholder="Inserisci il nome dell\'Impresa">' +
          '                                            <img class="icon-error" src="https://media.rds.it/web/web-site-brandnew/svg/icon-error.svg">' +
          "                                        </div>" +
          "                                    </fieldset>" +
          '                             <div id="error-message-mail" class="error-message-citta error-messages font-size-14 sofia_font"></div>' +
          "                           </div><br>" +
          '                                     <fieldset class="fieldset-gray fieldset-name">\n' +
          "                                        <legend>Partita Iva*</legend>" +
          '                                        <div class="flex align_center">' +
          '                                            <input id="piva" name="piva" class="register-input sofia_font" type="text" value=""' +
          '                                                   placeholder="Inserisci la Partita Iva">' +
          '                                            <img class="icon-error" src="https://media.rds.it/web/web-site-brandnew/svg/icon-error.svg">' +
          "                                        </div>" +
          "                                    </fieldset>" +
          '                             <div id="error-message-cf" class="error-message-citta error-messages font-size-14 sofia_font"></div>'
      );

      window.openPopup();
      $("#btnYesGame")
        .off()
        .click(function () {
          let user = JSON.parse(localStorage.getItem("rds_user"));

          if ($("#mailRapLegale").val().trim() == "") {
            $("#mailRapLegale")
              .parents(".fieldset-gray")
              .addClass("fieldset-error");
            $("#error-message-mail").text("Email tutore obbligatoria");
            return;
          } else {
            $("#mailGenitore")
              .parents(".fieldset-gray")
              .removeClass("fieldset-error");
            $("#error-message-mail").text("");
          }

          if ($("#nomeImpresa").val().trim() == "") {
            $("#nomeImpresa")
              .parents(".fieldset-gray")
              .addClass("fieldset-error");
            $("#error-message-mail").text("Nome Impresa obbligatorio");
            return;
          } else {
            $("#nomeImpresa")
              .parents(".fieldset-gray")
              .removeClass("fieldset-error");
            $("#error-message-mail").text("");
          }

          if (
            $("#piva").val().trim() != "" &&
            $("#piva").val().trim().length == 11
          ) {
            $("#btnYesGame").attr("id", "btnYes");
            $(".popup-messaggio-main").hide();
            yesCallback();
          } else {
            $("#piva").parents(".fieldset-gray").addClass("fieldset-error");
            $("#error-message-cf").text("Partita Iva non Valida");
          }
        });

      $("#btnNo")
        .off()
        .click(function () {
          $("#btnYesGame").attr("id", "btnYes");
          $(".popup-messaggio-main").hide();
          noCallback();
        });

      if (typeof postRenderCallback === "function") {
        postRenderCallback();
      }
    } catch (err) {
      return actualAlert(msg);
    }
  },

  confirmCustom(
    msg,
    subMsg,
    yesCallback,
    noCallback,
    yesButton,
    noButton,
    postRenderCallback
  ) {
    try {
      $(".img-warning")
        .find("img")
        .attr(
          "src",
          "https://media.rds.it/web/web-site-brandnew/svg/rds-problemi-accesso.svg"
        );

      $("#btnNo").show();
      $("#btnYes").html(yesButton);
      $("#btnNo").html(noButton);

      $("#messaggio_titolo_popup").html(msg);
      $("#messaggio_sottotitolo_popup").html(subMsg);

      window.openPopup();

      $("#btnYes")
        .off()
        .click(function () {
          $(".popup-messaggio-main").hide();
          yesCallback();
        });

      $("#btnNo")
        .off()
        .click(function () {
          $(".popup-messaggio-main").hide();
          noCallback();
        });

      if (typeof postRenderCallback === "function") {
        postRenderCallback();
      }
    } catch (err) {
      return actualAlert(msg);
    }
  },

  accettaContest(msg, subMsg, yesCallback, noCallback, yesButton, noButton) {
    try {
      $(".img-warning")
        .find("img")
        .attr(
          "src",
          "https://media.rds.it/web/web-site-brandnew/svg/rds-problemi-accesso.svg"
        );

      $("#btnNo").show();
      $("#btnYes").html(yesButton);
      $("#btnNo").html(noButton);

      $("#messaggio_titolo_popup").html(msg);
      $("#messaggio_sottotitolo_popup").html(subMsg);

      window.openPopup();

      $("#btnYes")
        .off()
        .click(function () {
          yesCallback();
        });
      $("#btnNo")
        .off()
        .click(function () {
          $(".popup-messaggio-main").hide();
          noCallback();
        });
    } catch (err) {
      return actualAlert(msg);
    }
  },

  confirmRiscattoPremio(msg, subMsg, yesCallback, yesButton) {
    try {
      $(".img-warning")
        .find("img")
        .attr(
          "src",
          "https://media.rds.it/web/web-site-brandnew/svg/rds-popup-successo2.svg"
        );

      $("#btnNo").hide();
      $("#btnYes").html(yesButton);

      $("#messaggio_titolo_popup").html(msg);
      $("#messaggio_sottotitolo_popup").html(subMsg);

      window.openPopup();

      $("#btnYes")
        .off()
        .click(function () {
          $(".popup-messaggio-main").hide();
          yesCallback();
        });
    } catch (err) {
      return actualAlert(msg);
    }
  },

  findGetParameter(parameterName) {
    var result = null,
      tmp = [];
    location.search
      .substr(1)
      .split("&")
      .forEach(function (item) {
        tmp = item.split("=");
        if (tmp[0] === parameterName) result = decodeURIComponent(tmp[1]);
      });
    return result;
  },
};

window.getDeviceBrowser = function () {
  if (
    (navigator.userAgent.indexOf("Opera") ||
      navigator.userAgent.indexOf("OPR")) != -1
  ) {
    return "opera";
  } else if (navigator.userAgent.indexOf("Chrome") != -1) {
    return "chrome";
  } else if (navigator.userAgent.indexOf("Safari") != -1) {
    return "safari";
  } else if (navigator.userAgent.indexOf("Firefox") != -1) {
    return "firefox";
  } else if (
    navigator.userAgent.indexOf("MSIE") != -1 ||
    !!document.documentMode == true
  ) {
    return "ie"; //crap
  } else {
    return "Unknown";
  }
};

window.getDeviceType = function () {
  var ua = navigator.userAgent;

  console.log("user agent -----> ", ua);

  if (/(tablet|ipad|playbook|silk)|(android(?!.*mobi))/i.test(ua)) {
    return "tablet";
  }
  if (
    /Mobile|iP(hone|od)|Android|BlackBerry|IEMobile|Kindle|Silk-Accelerated|(hpw|web)OS|Opera M(obi|ini)/.test(
      ua
    )
  ) {
    return "mobile";
  } else if (
    /Macintosh/i.test(navigator.userAgent) &&
    navigator.maxTouchPoints &&
    navigator.maxTouchPoints > 1
  ) {
    return "tablet";
  }
  return "desktop";
};

document.addEventListener('DOMContentLoaded', function() {
  const passwordInput = document.getElementById('user-password');
  const eye = document.getElementById('fa_eye');
  const eyeSlash = document.getElementById('fa_eye_slash');

  function togglePassword() {
    if (passwordInput.type === "password") {
      passwordInput.type = "text";
      eye.style.display = "inline";
      eyeSlash.style.display = "none";
    } else {
      passwordInput.type = "password";
      eye.style.display = "none";
      eyeSlash.style.display = "inline";
    }
  }
  eye.addEventListener('click', togglePassword);
  eyeSlash.addEventListener('click', togglePassword);
});

var actualAlert = window.alert;
export default new Utils();
